import MiniMap from './MiniMap';

export default MiniMap;
